import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import './MobileApps.css';

function MobileApps() {
  const features = [
    {
      title: 'Branded iOS & Android',
      body: 'Your logo, your colors, your name in the App Store and on Google Play. Customers download a real app, not a wrapped website.'
    },
    {
      title: 'Push notifications + booking',
      body: 'Appointment reminders, order updates, and re-engagement messages — delivered straight to your customer\'s lock screen.'
    },
    {
      title: 'Connected to your AI receptionist',
      body: 'Every tap, message, and booking inside the app flows through the same AI agent that answers your phone. One system, every channel.'
    }
  ];

  return (
    <section className="mobile-apps apps-band" id="mobile-apps">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="apps-band-eyebrow">
            <FaApple />
            <FaGooglePlay />
            <span>Also from UBOTIKA</span>
          </div>
          <h2>We also build mobile apps.</h2>
          <p className="apps-band-sub">
            Custom iOS &amp; Android apps, designed and shipped to the App Store and
            Google Play by us — wired to the same AI agent that answers your phone.
          </p>
          <ul className="apps-band-points">
            {features.map((f) => (
              <li key={f.title}>{f.title}</li>
            ))}
          </ul>
          <Link to="/free-missed-lead-audit" className="cta-button">
            Get a Free Audit
          </Link>
        </motion.div>

        <motion.figure
          className="apps-band-lab"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15 }}
          viewport={{ once: true }}
        >
          <video autoPlay loop muted playsInline>
            <source src="https://storage.googleapis.com/lupatest/dancing%20ubotika%20robot.mp4" type="video/mp4" />
          </video>
          <figcaption>From the UBOTIKA lab</figcaption>
        </motion.figure>
      </div>
    </section>
  );
}

export default MobileApps;
